import { PlaceResponse } from '@app/entities/place.response';

export enum PlaceSelectors {
  Country = 'country',
  City = 'city',
  Name = 'name',
  Statecode = 'statecode',
  AlternativeName = 'alternativeName'
}

export type Place = Readonly<{
  id: string;
  country: string;
  city: string;
  cityCode: string;
  is_airport?: boolean;
  statecode?: string;
}> & PlaceResponse;
